<template>
    <div>
        <tabs
            :items="sections"
            :active-item="section"
            class="mb-3"
            @item-change="section = $event"
        />

        <menus-edit v-model="content.menus" :v="$v.content" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import Tabs from '@/components/elements/Tabs';
import Base from '@/components/contents/Base';
import MenusEdit from '@/components/header/MenusEdit';

export default {
    components: {
        Tabs,
        MenusEdit
    },

    extends: Base,

    validations: {
        content: {
            menus: {
                $each: {
                    menuItems: {
                        $each: {
                            title: { required },
                            articles: {},
                            links: {
                                $each: {
                                    text: { required },
                                    redirect: { required }
                                }
                            },
                            subMenus: {
                                $each: {
                                    title: { required },
                                    items: {
                                        $each: {
                                            text: { required },
                                            redirect: { required }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },

    data() {
        return {
            sections: [
                {
                    value: 'menu',
                    text: 'Menu'
                }
            ],
            section: { value: 'menu' }
        };
    },

    async mounted() {
        try {
            for (const [menuIndex, menu] of this.content.menus.entries()) {
                const ids = menu.menuItems.flatMap(({ articles }) => articles);

                const articles = await this.getArticles(ids);

                const { menuItems } = this.content.menus[menuIndex];

                for (const [menuItemIndex, menuItem] of menuItems.entries()) {
                    for (const [
                        articleIndex,
                        article
                    ] of menuItem.articles.entries()) {
                        this.content.menus[menuIndex].menuItems[
                            menuItemIndex
                        ].articles[articleIndex] = articles.find(
                            ({ id }) => id === article
                        );
                    }
                }
            }
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getArticles: 'articles/bulkShow'
        }),

        beforeSave() {
            for (const [menuIndex] of this.content.menus.entries()) {
                for (const [menuItemIndex] of this.content.menus[
                    menuIndex
                ].menuItems.entries()) {
                    this.content.menus[menuIndex].menuItems[
                        menuItemIndex
                    ].articles = this.content.menus[menuIndex].menuItems[
                        menuItemIndex
                    ].articles
                        .filter(article => article && article.id)
                        .map(({ id }) => id);
                }
            }
        }
    }
};
</script>
